import React from 'react';

export const TotalsContext = React.createContext<{
  total_amount_sum?: number;
  total_transaction_count?: number;
}>({});